import React from 'react';
import '../../styles/components/dashboard/songs-progress-card.scss';

interface ISongsProgressCard {
  label: string,
  cardValue?: number,
  totalValue?: number,
}

export default function SongsProgressCard({label, cardValue, totalValue}: ISongsProgressCard) {
  return (
    <div className={`songs-progress-card`}>
      <dt className={`songs-card-values`}>
        <p className={`songs-card-value`}>{cardValue ?? `-`} <span className={`total-value`}>{totalValue}</span></p>
      </dt>
      <dd className={`songs-card-label`}>{label}</dd>
    </div>
  );
}
